import { useAuth } from "../../../context";
import { useMutation, useQuery } from "react-query";
import { SupplierCategories } from "../../../api";

export const supplierCategoriesKeys = {
  allSupplierCategories: () => ["allSupplierCategories"],
  paginatedSupplierCategories: () => ["paginatedSupplierCategories"]
};

export function useGetPaginatedSupplierCategories(paramsString, config) {
  const { callApi } = useAuth();
  return useQuery([...supplierCategoriesKeys.paginatedSupplierCategories(), paramsString],
    () => callApi(SupplierCategories.getPaginatedSupplierCategories, paramsString), config);
}

export function useCreateSupplierCategory(config) {
  const { callApi } = useAuth();
  return useMutation(data => callApi(SupplierCategories.createSupplierCategory, data), config);
}

export function useUpdateSupplierCategory(config) {
  const { callApi } = useAuth();
  return useMutation(({ id, data }) => callApi(SupplierCategories.updateSupplierCategory, { id, data }), config);
}

export function useDeleteSupplierCategory(config) {
  const { callApi } = useAuth();
  return useMutation(id => callApi(SupplierCategories.deleteSupplierCategory, id), config);
}

export function useGetAllSupplierCategories(config) {
  const { callApi } = useAuth();
  return useQuery(supplierCategoriesKeys.allSupplierCategories(),
    () => callApi(SupplierCategories.getAllSupplierCategories), config);
}

export function useDownloadSupplierCategoriesTemplate(config) {
  const { callApi } = useAuth();
  return useMutation(() => callApi(SupplierCategories.downloadSupplierCategoriesTemplate), config);
}

export function useImportSupplierCategories(config) {
  const { callApi } = useAuth();
  return useMutation(({ data }) => callApi(SupplierCategories.importSupplierCategories, { data }), config);
}